import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { identityText } from "../../../locales/en";

export const IsCreditConsentAccepted = (props) => {
  const { handleInfoModal, isChecked } = props;

  return (
    <>
      <p>{identityText?.useAdditionalComp.pleaseScan}</p>
      <div className="checkbox">
        <div className="d-flex align-items-start">
          <input
            name="kycIdentity"
            type="checkbox"
            id="kyc-consent"
            checked={isChecked}
            disabled
          />
          <label htmlFor="kyc-consent">
            {`${identityText?.useAdditionalComp.iConsent} `}
            <Link onClick={handleInfoModal}>
              {identityText?.useAdditionalComp.creditandUdentity}
            </Link>
          </label>
        </div>
      </div>
    </>
  );
};

IsCreditConsentAccepted.propTypes = {
  isChecked: PropTypes.bool,
  handleInfoModal: PropTypes.func.isRequired
};
